import { Pipe, PipeTransform, inject } from '@angular/core';
import { StaticContentService } from '@mwe/services';

@Pipe({ name: 'addStaticImagePath' })
export class AddStaticImagePathPipe implements PipeTransform {
  private staticContentService = inject(StaticContentService);

  transform(fileName: string): string {
    return `${this.staticContentService.getImagePath()}${fileName}`;
  }
}
